import React from 'react';
import {Message} from '@aperza/ui';
import AppService from '../service/AppService';
import type AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class FooterSocialLinks extends React.Component {

  render() {

    return (
      <ul className="strip footer-social-links" style={{justifyContent: 'space-between'}}>
        <li><a className="sns-fb" href={`https://www.facebook.com/news.aperza/`}><i className="fa fa-facebook-square"></i></a></li>
        <li><a className="sns-ins" href={`https://www.instagram.com/monozukuri_news/`}><i className="fa fa-instagram"></i></a></li>
        <li><a className="sns-tw" href={`https://twitter.com/news_aperza`}><i className="fa fa-twitter"></i></a></li>
        <li><a className="sns-yt" href={`https://www.youtube.com/channel/UCEPoZF8KKr2Hm0QiBympWOA/videos`}><i className="fa fa-youtube-play"></i></a></li>
      </ul>
    )
  }

}
